// extracted by mini-css-extract-plugin
export default {"container":"logout-dialog_container__FBp8g","logout-btn":"logout-dialog_logout-btn__SIHYO","cancel-btn":"logout-dialog_cancel-btn__ay7S0"};